import React, { useContext } from "react";

import PermissionWrapper from "../../../../../../../global/PermissionWrapper";
import { StaticBarStateContext } from "../../context/StaticBarContext";
import { BirthDate } from "../fields/BirthDate/BirthDate";
import Campaigns from "../fields/Campaigns";
import CommunicationStatus from "../fields/CommunicationStatus";
import DoNotContact from "../fields/DoNotContact";
import Name from "../fields/Name";
import PhoneNumber from "../fields/PhoneNumber";
import PreferredLanguage from "../fields/PreferredLanguage";
import RelatedCases from "../fields/RelatedCases";
import Column from "../ui/Column";

const ClientInfoSummary = () => {
  const state = useContext(StaticBarStateContext);

  const ageFlagState = state.data?.age?.flag_state;
  const hasAgeRelatedCases = state.data?.relatedCases?.value?.length > 0;
  return (
    <Column>
      <div className="flex">
        {state?.data?.name && (
          <PermissionWrapper permission={state?.data?.name?.can_view}>
            <Name
              fieldName={state.data?.name?.fieldName}
              prefix={state.data?.namePrefix?.value}
              name={state.data?.name?.value}
              flag={state.data?.name?.flag_state}
              clock={state.data?.name?.clock_state}
            />
          </PermissionWrapper>
        )}
        {state?.data?.campaign && (
          <PermissionWrapper permission={state?.data?.campaign?.can_view}>
            <Campaigns
              fieldName={state.data?.campaign?.fieldName}
              campaign={state.data?.campaign?.value}
              flag={state.data?.campaign?.flag_state}
              clock={state.data?.campaign?.clock_state}
            />
          </PermissionWrapper>
        )}
      </div>
      {state.data?.dateOfBirth && state.data?.age && (
        <PermissionWrapper permission={state.data?.dateOfBirth?.can_view}>
          <BirthDate
            fieldName={state.data?.dateOfBirth?.fieldName}
            dateOfBirth={state.data?.dateOfBirth?.value}
            age={state.data?.age?.value}
            minorCheck={state.data?.age?.flag_state}
            needsValidation={state.ui?.age?.needsValidation}
            flag={state.data?.age?.flag_state}
            clock={state.data?.age?.clock_state}
          />
        </PermissionWrapper>
      )}
      {state.data?.preferredLanguage && (
        <PermissionWrapper permission={state.data?.preferredLanguage?.can_view}>
          <PreferredLanguage
            fieldName={state.data?.preferredLanguage?.fieldName}
            value={state.data?.preferredLanguage?.value}
            flag={state.data?.preferredLanguage?.flag_state}
            clock={state.data?.preferredLanguage?.clock_state}
          />
        </PermissionWrapper>
      )}
      <div className="flex h-[32px]">
        {state.data?.phone && (
          <PermissionWrapper permission={state.data?.phone?.can_view}>
            <PhoneNumber
              fieldName={state.data?.phone?.fieldName}
              number={state.data?.phone?.value}
              flag={state.data?.phone?.flag_state}
              clock={state.data?.phone?.clock_state}
            />
          </PermissionWrapper>
        )}
        <div
          className="flex space-x-2 p-0"
          style={{
            marginTop: ageFlagState > 1 || hasAgeRelatedCases ? "-10px" : "0",
          }}
        >
          {state.data?.relatedCases && hasAgeRelatedCases && (
            <PermissionWrapper permission={state.data?.relatedCases?.can_view}>
              <RelatedCases relatedCases={state.data?.relatedCases?.value} />
            </PermissionWrapper>
          )}
          {!ageFlagState && (
            <PermissionWrapper permission={state.data?.age?.can_view}>
              <DoNotContact minorCheck={ageFlagState} />
            </PermissionWrapper>
          )}
        </div>
      </div>
      {state.data?.commStatus && (
        <PermissionWrapper permission={state.data?.commStatus?.can_view}>
          <CommunicationStatus
            fieldName={state.data?.commStatus?.fieldName}
            value={state.data?.commStatus?.value}
            flag={state.data?.commStatus?.flag_state}
            clock={state.data?.commStatus?.clock_state}
          />
        </PermissionWrapper>
      )}
    </Column>
  );
};

export default ClientInfoSummary;
